module.exports = __webpack_public_path__ + "project_defaultwp7836f8ff25cbef1ff45bd0eaf4e1977e.png";